// ============================================
// Project: FORGE - Universal MCP Tool Server
// Author: Telvin Crasta | CC BY-NC 4.0
// ============================================

import './styles/globals.css';
import DashboardPage from './pages/DashboardPage';

export default function App() {
  return <DashboardPage />;
}
